import React from "react";
const RenderComponent = ({component, ...props}) => {

    const Comp = component;
    
    if(Comp)
        return <Comp {...props} />
}

export default RenderComponent;